import React, { useEffect, useRef, useState } from 'react'
import Grid from '@mui/material/Grid2';
import { useNavigate, useParams } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleRight } from '@fortawesome/free-solid-svg-icons';
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import dayjs from 'dayjs';
import Select from "react-select";
import "./jobboard.css"
import JoditEditor from "jodit-react";
import { apiService } from '../../services/apiService';
import { toast } from 'react-toastify';
import debounce from 'lodash.debounce';
function EditJobs() {
    const citizenshipStatuses =[
        {
            "id": 1,
            "status": "CPT"
        },
        {
            "id": 5,
            "status": "GC"
        },
        {
            "id": 2,
            "status": "GC EAD"
        },
        {
            "id": 4,
            "status": "H1B"
        },
        {
            "id": 8,
            "status": "H4 EAD"
        },
        {
            "id": 3,
            "status": "L2 EAD"
        },
        {
            "id": 7,
            "status": "OPT EAD"
        },
        {
            "id": 6,
            "status": "USC"
        }
    ];
    const contentRef = useRef("");
    const debouncedOnChange = debounce((value) => {
    const cleanValue = value === "<p><br></p>" ? "" : value;
    contentRef.current = cleanValue;
    }, 500);
    
    const { slug } = useParams();
    const navigate = useNavigate();
    const [value, setValue] = useState(dayjs(null));
    const [loading, setLoading] = useState(true);
    const [submitloader, setSubmitloader] = useState(false);
    const [errors, setErrors] = useState({});
    const [jobPostId, setJobpostId] = useState('');
    const [errorMessage, setErrorMessage] = useState('');
    const [opendata, setOpendata] = useState();
    const [openEmaildata, setEmaildata] = useState(true);
    const [states, setStates] = useState([]);
    const [formData, setFormData] = useState({
        type: "",
        job_url: "",
        job_type: "",
        published_on: "",
        source: "",
        number_of_openings: "",
        salary_min: "",
        salary_max: "",
        experience_range: "",
        work_city: "",
        work_state: "",
        site_type: "",
        citizenship_status: "",
        restricted_citizenship_status: "",
        technology: "ServiceNow",
        key_skills: "",
        role_type: "",
        poster_type: "",
        recruiter_name: "",
        recruiter_email: "",
        recruiter_company: "",
        recruiter_phone: "",
        description: "",
        title: "",
        salary_type: "",
    });
    const styles = {
        tagContainer: {
            display: "flex",
            flexWrap: "wrap",
            padding: "0px",
            border: "none",
            borderRadius: "5px",
        },
        tag: {
            display: "flex",
            alignItems: "center",
            backgroundColor: "#B8D7FF",
            borderRadius: "3px",
            padding: "5px",
            marginRight: "5px",
            marginBottom: "5px",
            fontWeight:"600",
        },
        removeButton: {
            marginLeft: "5px",
            border: "none",
            background: "transparent",
            cursor: "pointer",
            fontSize: "16px",
        },
    };

    useEffect(() => {
        const fetchPreviewData = async () => {
            setLoading(true)
            try {
            const response = await apiService.getRequest(`job-posts/${slug}`);
            if(response && response.success === true){
                // setPreviewData(Array.isArray(response.data) ? response.data : [response.data]);
                // setPreviewData(response.data);
                // setStatus(response.data.status);
                setJobpostId(response.data.id);
                const existingTags = response.data.key_skills ? response.data.key_skills.map(tag => tag.trim()) : [];
                setSkills(existingTags);
                if(response.data && response.data.description_html.length > 0){
                    contentRef.current = response.data.description_html;
                }else{
                    contentRef.current = response.data.description;
                }
                setFormData({
                    type: response.data.type || "",
                    job_url: response.data.job_url || "",
                    job_type: response.data.job_type || "",
                    published_on: response.data.published_on || "",
                    source: response.data.source || "",
                    site_type: response.data.site_type || "",
                    number_of_openings: response.data.number_of_openings || "",
                    salary_min: response.data.salary_min || "unknown",
                    salary_max: response.data.salary_max || "unknown",
                    salary_type: response.data.salary_type || "unknown",
                    experience_range: response.data.experience_range || "",
                    work_state: response.data.work_state || "unknown",
                    work_city: response.data.work_state ? response.data.work_city : "unknown",
                    citizenship_status: response.data.citizenship_status || "",
                    restricted_citizenship_status: response.data.restricted_citizenship_status || "",
                    technology: "ServiceNow",
                    key_skills: Array.isArray(response.data.key_skills) ? response.data.key_skills.map(tag => tag.trim()).join(', ') : '',
                    recruiter_email: response.data.recruiter_email || "",
                    role_type: response.data.role_type || "",
                    poster_type: response.data.poster_type || "",
                    recruiter_name: response.data.recruiter_name || "",
                    recruiter_company: response.data.recruiter_company || "",
                    recruiter_phone: response.data.recruiter_phone || "",
                    description: response.data.description_html || "",
                    title: response.data.title || "",
                });
                setRecruiterEmail(response.data.recruiter_email[0] !== "" && response.data.recruiter_email[0] !== "unknown" ? response.data.recruiter_email : []);
                if(response.data.citizenship_status === "unknown" || (Array.isArray(response.data.citizenship_status) && response.data.citizenship_status.includes("unknown"))){
                    setStatusCity(null);
                }else{
                    setStatusCity(
                        response.data.citizenship_status.map(role => ({ value: role, label: role })) || [],
                    )
                }
                if(response.data.restricted_citizenship_status === "unknown" || (Array.isArray(response.data.restricted_citizenship_status) && response.data.restricted_citizenship_status.includes("unknown"))){
                    setResStatusCity(null);
                }else{
                    setResStatusCity(
                        response.data.restricted_citizenship_status.map(role => ({ value: role, label: role })) || [],
                    )
                }
                if (response.data.work_state === "unknown" || response.data.work_state === "" || response.data.work_state === null ) {
                    setSelectedState(null);
                    setSelectedCity(null);
                }else{
                    const statesets = await apiService.postRequest(`states-list/US`);
                    if(statesets.success){
                        setStates(statesets.data || []);
                        setTimeout(() => {
                            const selectedState = statesets.data.find((state) => state.abbreviation === response.data.work_state);
                            if (selectedState) {
                                setSelectedState({ label: selectedState.name, value: selectedState.abbreviation });
                            }
                        }, 0);        
                        if (response.data.work_city && response.data.state_code !== "unknown") {
                            const responseCities = await apiService.postRequest(`cities/${response.data.work_state}`);
                            if (responseCities.success) {
                                setCities(responseCities.data || []);
                                setTimeout(() => {
                                    const selectedCity = responseCities.data.find((city) => city.id === Number(response.data.work_city));
                                    if (selectedCity) {
                                        setSelectedCity({ label: selectedCity.city_name +", "+ selectedCity.state_code, value: selectedCity.id });
                                    }
                                }, 0);
                            }
                        }
                    }
                }
                if (response.data.published_on) {
                    const parsedDob = dayjs(response.data.published_on, 'YYYY-MM-DD');
                    if (parsedDob.isValid()) {
                        setValue(parsedDob); 
                    }
                }
                if (response.data.type === 'Online') {
                    setOpendata(true);
                } else {
                    setOpendata(false);
                }
                if (response.data.type === 'Email') {
                    setEmaildata(false);
                } else {
                    setEmaildata(true);
                }
            }else{
                if(response.authenticate === false){
                    await apiService.postRequest('/auth/logout');
                    localStorage.clear();
                    sessionStorage.clear();
                    window.location.href = '/login';
                }
            }
            } catch (error) {
            console.error('Error fetching group data:', error);
            }finally{
            setLoading(false)
            }
        };
    
        fetchPreviewData();
    }, [slug]);
    const [key_skills, setSkills] = useState([]);
    const [input, setInput] = useState("");
    const [recruiter_email, setRecruiterEmail] = useState([]);
    const [input2, setInput2] = useState("");
    const [cities, setCities] = useState([]);
    const [selectedState, setSelectedState] = useState(null);
    const [selectedCity, setSelectedCity] = useState(null);
    const [selectedStatusCity, setStatusCity] = useState(null);
    const [selectedResStatusCity, setResStatusCity] = useState(null);

    const handlePhoneNumberChange = (e) => {
        const inputElement = e.target;
        const inputValue = inputElement.value;
        const cursorPosition = inputElement.selectionStart;

        let formattedInput = inputValue.replace(/\D/g, ''); // Remove non-digit characters

        if (formattedInput.length > 3 && formattedInput.length <= 6) {
            formattedInput = formattedInput.replace(/(\d{3})(\d+)/, '($1) $2'); // Format (123) 456
        } else if (formattedInput.length > 6) {
            formattedInput = formattedInput.replace(/(\d{3})(\d{3})(\d+)/, '($1) $2-$3'); // Format (123) 456-7890
        } else if (formattedInput.length <= 3) {
            formattedInput = `(${formattedInput}`; // Start formatting with open bracket (123
        }

        setFormData({ ...formData, recruiter_phone: formattedInput });

        const newCursorPosition = cursorPosition + (formattedInput.length - inputValue.length);
        setTimeout(() => {
            inputElement.selectionStart = newCursorPosition;
            inputElement.selectionEnd = newCursorPosition;
        }, 0);

        // Phone number validation
        let validationErrors = { ...errors };
         if (!/^\(\d{3}\) \d{3}-\d{4}$/.test(formattedInput)) {
            validationErrors.recruiter_phone = 'Phone number must be in the format: (123) 456-7890';
        } else {
            delete validationErrors.recruiter_phone;
        }

        setErrors(validationErrors);
    };
    const handleInputChanger = (e) => {
        setInput(e.target.value);
        if (errors.key_skills) {
            setErrors(prevErrors => ({ ...prevErrors, key_skills: undefined }));
        }
    };

    const handleKeyDown = (e) => {
        if (e.key === "Enter" && input.trim()) {
            e.preventDefault();
            const newTag = input.trim();
            if (!key_skills.includes(newTag)) {
                const updatedkey_skills = [...key_skills, newTag];
                setSkills(updatedkey_skills);

                // Update the formData tag property to a comma-separated string or join the key_skills array as needed
                setFormData((prevFormData) => ({
                    ...prevFormData,
                    key_skills: updatedkey_skills.join(", "), // Join key_skills into a single string if needed
                }));
            }
            setInput("");
        }
    };

    const removeTag = (index) => {
        const updatedkey_skills = key_skills.filter((tag, i) => i !== index);
        setSkills(updatedkey_skills);

        // Update the formData tag property to reflect the removed tag
        setFormData((prevFormData) => ({
            ...prevFormData,
            key_skills: updatedkey_skills.join(", "), // Update to a comma-separated string if needed
        }));
    };
    const handleInputChanger2 = (e) => {
        setInput2(e.target.value);
        if (errors.recruiter_email) {
            setErrors(prevErrors => ({ ...prevErrors, recruiter_email: undefined }));
        }
    };

    const handleKeyDown2 = (e) => {
        if (e.key === "Enter" && input2.trim()) {
            e.preventDefault();
            const newTag = input2.trim();
            if (!recruiter_email.includes(newTag)) {
                const updatedrecruiter_email = [...recruiter_email, newTag];
                setRecruiterEmail(updatedrecruiter_email);

                // Update the formData tag property to a comma-separated string or join the key_skills array as needed
                setFormData((prevFormData) => ({
                    ...prevFormData,
                    recruiter_email: updatedrecruiter_email.join(", "), // Join key_skills into a single string if needed
                }));
            }
            setInput2("");
        }
    };

    const removeTag2 = (index) => {
        const updatedrecruiter_email = recruiter_email.filter((tag, i) => i !== index);
        setRecruiterEmail(updatedrecruiter_email);

        // Update the formData tag property to reflect the removed tag
        setFormData((prevFormData) => ({
            ...prevFormData,
            recruiter_email: updatedrecruiter_email.join(", "), // Update to a comma-separated string if needed
        }));
    };
    const handleDateChange = (newValue) => {
        if (newValue) {
            setValue(newValue);
            setFormData({ ...formData, published_on: newValue.format('YYYY-MM-DD') });
    
            // Clear the error for published_on if a valid date is entered
            if (errors.published_on) {
                setErrors({ ...errors, published_on: '' });
            }
        } else {
            setValue(null);
            setFormData({ ...formData, published_on: '' }); // Clear the value if null
        }
    };
    // const handleEditorChange = (htmlContent) => {
    //     setFormData((prevFormData) => ({
    //         ...prevFormData,
    //         description: htmlContent,
    //     }));

    //     // Clear content error if the user starts typing
    //     setErrors((prevErrors) => ({
    //         ...prevErrors,
    //         description: '',
    //     }));
    // };
    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData((prevData) => ({ ...prevData, [name]: value ?? "" }));
        setErrors((prevErrors) => ({ ...prevErrors, [name]: '' }));
        if (name === 'type') {
            if (value === 'Online') {
                setOpendata(true);
                setFormData(prevData => ({
                    ...prevData,
                    recruiter_email: '',
                }));
            } else {
                setOpendata(false);
                setFormData(prevData => ({
                    ...prevData,
                    job_url: '',
                    source: '',
                }));
            }
            if(value === "Email"){
                setEmaildata(false);
            }else{
                setEmaildata(true);
            }
        }
    }
    useEffect(() => {
        const fetchData = async () => {
            const response = await apiService.postRequest(`states-list/US`);
            if (response.success) {
                setStates(response.data);
                setSelectedState(null);
            }
        };
        fetchData();
    }, []);
    useEffect(() => {
        if (formData.work_state && formData.work_state !== "unknown") {
            const fetchData = async () => {
                const response = await apiService.postRequest(`cities-list/${formData.work_state}`);
                if (response.success) {
                    setCities(response.data || []);
                    setSelectedCity(null);
                }
            };
            fetchData();
        }
    }, [formData.work_state]);
    const handleStateChange = (selectedOption) => {
        setSelectedState(selectedOption);
        handleInputChange({
            target: {
                name: 'work_state',
                value: selectedOption ? selectedOption.value : ''
            }
        });
        setSelectedCity(null);
    };

    const handleCityChange = (selectedOption) => {
        setSelectedCity(selectedOption); // Update living_city
        handleInputChange({
            target: {
                name: 'work_city',
                value: selectedOption ? selectedOption.value : ''
            }
        });
    };
    const handleStatusChange = (selectedOption) => {
        setStatusCity(selectedOption); // Update living_city
        handleInputChange({
            target: {
                name: 'citizenship_status',
                value: selectedOption ? selectedOption.map(option => option.value) : []
            }
        });
    };
    const handleResStatusChange = (selectedOption) => {
        setResStatusCity(selectedOption); // Update living_city
        handleInputChange({
            target: {
                name: 'restricted_citizenship_status',
                value: selectedOption ? selectedOption.map(option => option.value) : []
            }
        });
    };
    
    const handleSubmit = async (e) => {
        e.preventDefault();
        const contentValue = contentRef.current;
      
        const updatedFormData = {
          ...formData,
          description: contentValue,
        };
        setFormData(updatedFormData);
        setErrors({});
        let validationErrors = {};

        if (opendata) {
            if (formData.job_url.length > 2000) {
                validationErrors.job_url = ['Job post URL must be less than 2000 characters long.'];
            }
        }
        if (formData.title.length > 200) {
            if(openEmaildata){
                validationErrors.title = ['Title must be less than 200 characters long.'];
            }else{
                validationErrors.title = ['Email Subject must be less than 200 characters long.'] 
            }
        }
        if (formData.recruiter_company.length > 200) {
            validationErrors.recruiter_company = ['Recruiter company must be less than 200 characters long.'];
        }
        if (formData.recruiter_name.length > 200) {
            validationErrors.recruiter_name = ['Recruiter name must be less than 200 characters long.'];
        }
        if (Object.keys(validationErrors).length > 0) {
            setErrors(validationErrors);
            return; // Stop the function from proceeding
        }
        setSubmitloader(true);
        try {
            const filteredData = { ...updatedFormData };
            if (opendata === true) {
                delete filteredData.recruiter_email;
            }else{
                delete filteredData.source;
            }
            const fieldsToRemove = ["salary_max", "salary_min"];
            const fieldsToSendAsArray = ["citizenship_status", "restricted_citizenship_status"];
            
            fieldsToRemove.forEach((field) => {
                if (filteredData[field] === "unknown") {
                    delete filteredData[field];
                }
            });
            fieldsToSendAsArray.forEach((field) => {
                if (filteredData[field] === "unknown") {
                    filteredData[field] = ["unknown"];
                }
            });
            if (typeof filteredData.recruiter_email === 'undefined') {
                delete filteredData.recruiter_email;
            } else if (Array.isArray(filteredData.recruiter_email)) {
                filteredData.recruiter_email = filteredData.recruiter_email.join(',');
            } else if (typeof filteredData.recruiter_email !== 'string') {
                filteredData.recruiter_email = String(filteredData.recruiter_email);
            }
            const response = await apiService.patchRequest(`job-posts/${jobPostId}`, filteredData);

            // Check if the response indicates success
            if (response && response.success === true) {
                toast(response.message || "Job post created successfully.")
                navigate("/job-board");
                setErrors({});
                setErrorMessage('');
            }else{
                setErrorMessage(response.message);
                setErrors(response.errors || "");
                if(response.authenticate === false){
                    await apiService.postRequest('/auth/logout');
                    localStorage.clear();
                    sessionStorage.clear();
                    window.location.href = '/login';
                }
            }
        } catch (error) {
            console.log("err",error);
        }finally {
            setSubmitloader(false); // Stop loader
        }
    };
  return (
    <div className='container-fluid px-0'>
        <div className='content_container'>
            <Grid size={{sm:12}} container className="main_jobseeker">
                <Grid size={{md:12,xs:12}} container flexDirection="column" className="jobseekerhead">
                    <h3>Job Board</h3>
                    <span><b onClick={()=>navigate("/dashboard")}>Dashboard</b> <FontAwesomeIcon className='angleright' icon={faAngleRight} /> Job Board <FontAwesomeIcon className='angleright' icon={faAngleRight} /> Edit Job</span>
                </Grid>
                {loading ? 
                    <div className='d-flex justify-content-center w-100 mt-5'>
                        <img style={{ width: "100px" }} src={require('../../assets/pinkloader.gif')} alt='Loading...' />
                    </div> :
                    <Grid size={{xs:12}} container justifyContent="center">
                        <form className='row justify-content-center w-100'>
                            <Grid size={{ xs: 12 }} container justifyContent="space-between" alignItems="center" className="mt-4 mb-3 add_jobhead">
                                <Grid size={{ sm:5,xs: 12 }} container flexDirection="column">
                                    <h4>Edit Job Post</h4>
                                </Grid>
                                <Grid size={{ sm:6,xs: 12 }} container alignItems="center" className="gap-3" justifyContent="end">
                                    <button type="button" onClick={handleSubmit} className='registersendbtn2'>{submitloader ? <img src={require('../../assets/whiteloader.gif')} alt=''/> : 'Submit'}</button>
                                    <button type='button' className='registersendbtn1' onClick={()=>navigate("/job-board")}>Cancel</button>
                                </Grid>
                            </Grid>
                            <Grid size={{sm:12,xs:12}} container justifyContent="space-between" className="regiter_inputs i94validateinput">
                                
                                <Grid size={{sm:5.5, xs:12}} container flexDirection="column" >
                                    <span>Type<small >*</small></span>
                                    <select name="type" value={formData.type} onChange={handleInputChange}>
                                        <option value="">Select</option>
                                        <option value="Online">Online</option>
                                        <option value="Email">Email</option>
                                    </select>
                                    {errors.type && <p style={{color:"red"}}>{errors.type}</p>}
                                </Grid>
                                {opendata &&
                                    <Grid size={{sm:12, xs:12}} container flexDirection="column" >
                                        <span>Job Post URL<small >*</small></span>
                                        <input type="text" name="job_url" value={formData.job_url} maxLength="2001" onChange={handleInputChange}/>
                                        {errors.job_url && <p style={{color:"red"}}>{errors.job_url}</p>}
                                    </Grid>
                                }
                                <Grid size={{sm:5.5, xs:12}} container flexDirection="column" >
                                    <span>Published On<small >*</small></span>
                                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                                        <DatePicker
                                            className="date_pickermux"
                                            value={value}
                                            onChange={handleDateChange}
                                            maxDate={dayjs()}
                                            minDate={dayjs().subtract(3, 'month')}
                                            renderInput={(params) => <input {...params} />}
                                        />
                                    </LocalizationProvider>
                                    {errors.published_on && <p style={{color:"red"}}>{errors.published_on}</p>}
                                </Grid>
                                <Grid size={{sm:5.5, xs:12}} container flexDirection="column" >
                                    <span>Job Type<small className={formData.job_type==="unknown" ? "grayed_star":""}>*</small></span>
                                    <select name="job_type" value={formData.job_type} onChange={handleInputChange} disabled={formData.job_type === "unknown"}>
                                        <option value="">Select</option>
                                        <option value="Full-time">Full-time</option>
                                        <option value="Part-time">Part-time</option>
                                        <option value="Contract">Contract</option>
                                        <option value="Temporary">Temporary</option>
                                        <option value="Internship">Internship</option>
                                    </select>
                                    <span className='mt-0 job_boardspancheckadd'>
                                        <input type='checkbox' checked={formData.job_type === "unknown"}
                                        onChange={(e) => 
                                            handleInputChange({
                                            target: { name: "job_type", value: e.target.checked ? "unknown" : "" }
                                            })
                                        }/>
                                    Unknown</span>
                                    {errors.job_type && <p style={{color:"red"}}>{errors.job_type}</p>}
                                </Grid>
                                {opendata &&
                                    <Grid size={{sm:5.5, xs:12}} container flexDirection="column" >
                                        <span>Source<small className={formData.source==="Other" ? "grayed_star":""}>*</small></span>
                                        <select name="source" value={formData.source} onChange={handleInputChange} disabled={formData.source === "Other"}>
                                            <option value="">Select</option>
                                            <option value="TekP Intelligence">TekP Intelligence</option>
                                            <option value="LinkedIn">LinkedIn</option>
                                            <option value="Monster">Monster</option>
                                            <option value="Indeed">Indeed</option>
                                            <option value="Glassdoor">Glassdoor</option>
                                            <option value="Dice">Dice</option>
                                            <option value="Techfetch">Techfetch</option>
                                        </select>
                                        <span className='mt-0 job_boardspancheckadd'>
                                            <input type='checkbox' checked={formData.source === "Other"}
                                            onChange={(e) => 
                                                handleInputChange({
                                                target: { name: "source", value: e.target.checked ? "Other" : "" }
                                                })
                                            }/>
                                        Other</span>
                                        {errors.source && <p style={{color:"red"}}>{errors.source}</p>}
                                    </Grid>
                                }
                                <Grid size={{sm:5.5, xs:12}} container flexDirection="column" >
                                    <span>Site Type<small className={formData.site_type==="unknown" ? "grayed_star":""}>*</small></span>
                                    <select name="site_type" value={formData.site_type} onChange={handleInputChange} disabled={formData.site_type === "unknown"}>
                                        <option value="">Select</option>
                                        <option value="Remote">Remote</option>
                                        <option value="Onsite">Onsite</option>
                                        <option value="Hybrid">Hybrid</option>
                                    </select>
                                    <span className='mt-0 job_boardspancheckadd'>
                                        <input type='checkbox' checked={formData.site_type === "unknown"}
                                        onChange={(e) => 
                                            handleInputChange({
                                            target: { name: "site_type", value: e.target.checked ? "unknown" : "" }
                                            })
                                        }/>
                                    Unknown</span>
                                    {errors.site_type && <p style={{color:"red"}}>{errors.site_type}</p>}
                                </Grid>
                                <Grid size={{sm:5.5, xs:12}} container flexDirection="column" >
                                    <span>Number of Openings<small className={formData.number_of_openings==="unknown" ? "grayed_star":""}>*</small></span>
                                    <input type="text" name="number_of_openings" value={formData.number_of_openings} onChange={handleInputChange} disabled={formData.number_of_openings === "unknown"} onInput={(e) => e.target.value = e.target.value.replace(/[^0-9]/g, '')}/>
                                    <span className='mt-0 job_boardspancheckadd'>
                                        <input type='checkbox' checked={formData.number_of_openings === "unknown"}
                                        onChange={(e) => 
                                            handleInputChange({
                                            target: { name: "number_of_openings", value: e.target.checked ? "unknown" : "" }
                                            })
                                        }/>
                                    Unknown</span>
                                    {errors.number_of_openings && <p style={{color:"red"}}>{errors.number_of_openings}</p>}
                                </Grid>
                                <Grid size={{sm:5.5, xs:12}} container flexDirection="column">
                                    <span>Work State<small className={formData.work_state==="unknown" ? "grayed_star":""}>*</small></span>
                                    <Select
                                        className="basic-single select_withsearch"
                                        classNamePrefix="select"
                                        value={selectedState}
                                        defaultValue={null}
                                        isDisabled={formData.work_state === "unknown"}
                                        name="work_state"
                                        options={states && states.map((living_state) => ({
                                            label: living_state.name,
                                            value: living_state.abbreviation,
                                        }))}
                                        onChange={handleStateChange}
                                    />
                                    <span className='mt-1 job_boardspancheckadd'>
                                        <input type='checkbox' checked={formData.work_state === "unknown"}
                                        onChange={(e) => {
                                            handleInputChange({
                                            target: { name: "work_state", value: e.target.checked ? "unknown" || null : "" }
                                            });
                                            setSelectedState(null);
                                            handleInputChange({
                                            target: { name: "work_city", value: e.target.checked ? "unknown" : "" }
                                            });
                                            setSelectedCity(null)
                                        }
                                        }/>
                                    Unknown</span>
                                    {errors.work_state && <p style={{color:"Red"}}>{errors.work_state}</p>}
                                </Grid>
                                <Grid size={{sm:5.5, xs:12}} container flexDirection="column">
                                    <span>Work City<small className={formData.work_city ==="unknown" ? "grayed_star":""}>*</small></span>
                                    <Select
                                        className="basic-single select_withsearch"
                                        classNamePrefix="select"
                                        value={selectedCity}
                                        defaultValue={null}
                                        isDisabled={formData.work_city === "unknown"}
                                        name="work_city"
                                        options={cities && cities.map((living_city) => ({
                                            label: `${living_city.city_name}, ${living_city.state_code}`,
                                            value: `${living_city.id}`,
                                        }))}
                                        onChange={handleCityChange}
                                    />
                                    <span className='mt-1 job_boardspancheckadd'>
                                        <input type='checkbox' checked={formData.work_city === "unknown"}
                                        onChange={(e) => {
                                            handleInputChange({
                                            target: { name: "work_city", value: e.target.checked ? "unknown" : "" }
                                            });
                                            setSelectedCity(null);
                                            if(formData.work_state === "unknown"){
                                                handleInputChange({
                                                target: { name: "work_state", value: e.target.checked ? "unknown" : "" }
                                                });
                                                setSelectedState(null);
                                            }
                                        }}/>
                                    Unknown</span>
                                    {errors.work_city && <p style={{color:"Red"}}>{errors.work_city}</p>}
                                </Grid>
                                <Grid size={{xs:12}} container alignContent="flex-start" justifyContent="space-between">
                                    <Grid size={{sm:5.5, xs:12}} container alignContent="flex-start" justifyContent="space-between">
                                        <Grid size={{xs:12}} container flexDirection="column" >
                                            <span>Salary Type<small className={formData.salary_type==="unknown" ? "grayed_star":""}>*</small></span>
                                            <select name="salary_type" value={formData.salary_type} onChange={handleInputChange} disabled={formData.salary_type === "unknown"}>
                                                <option value="">Select</option>
                                                <option value="hourly">Hourly</option>
                                                <option value="yearly">Yearly</option>
                                            </select>
                                            {errors.salary_type && <p style={{color:"red"}}>{errors.salary_type}</p>}
                                        </Grid>
                                        <span className='mt-0 job_boardspancheckadd'>
                                            <input type='checkbox'
                                            checked={formData.salary_type === "unknown"}
                                            onChange={(e) => {
                                            const isChecked = e.target.checked;
                                            handleInputChange({
                                                target: { name: "salary_min", value: isChecked ? "unknown" : "" },
                                            });
                                            handleInputChange({
                                                target: { name: "salary_max", value: isChecked ? "unknown" : "" },
                                            });
                                            handleInputChange({
                                                target: { name: "salary_type", value: isChecked ? "unknown" : "" },
                                            });
                                            }}/>
                                        Unknown</span>
                                    </Grid>
                                    <Grid size={{sm:5.5, xs:12}} container alignContent="flex-start" justifyContent="space-between">
                                        <Grid size={{sm:5.5, xs:12}} container flexDirection="column" >
                                            <span>Salary Range Min<small className={formData.salary_min==="unknown" ? "grayed_star":""}>*</small></span>
                                            <input type='text' name="salary_min" value={formData.salary_min} onChange={handleInputChange} disabled={formData.salary_min === "unknown"} onInput={(e) => e.target.value = e.target.value.replace(/[^0-9]/g, '')}/>
                                            {errors.salary_min && <p style={{color:"red"}}>{errors.salary_min}</p>}
                                        </Grid>
                                        <Grid size={{sm:5.5, xs:12}} container flexDirection="column" >
                                            <span>Salary Range Max<small className={formData.salary_max==="unknown" ? "grayed_star":""}>*</small></span>
                                            <input type='text' name="salary_max" value={formData.salary_max} onChange={handleInputChange} disabled={formData.salary_max === "unknown"} onInput={(e) => e.target.value = e.target.value.replace(/[^0-9]/g, '')}/>
                                            {errors.salary_max && <p style={{color:"red"}}>{errors.salary_max}</p>}
                                        </Grid>
                                    </Grid>
                                </Grid>
                                <Grid size={{sm:5.5, xs:12}} container flexDirection="column" >
                                    <span>Experience Range<small className={formData.experience_range==="unknown" ? "grayed_star":""}>*</small></span>
                                    <select name="experience_range" value={formData.experience_range} onChange={handleInputChange} disabled={formData.experience_range === "unknown"}>
                                        <option value="">Select</option>
                                        <option value="No experience">No experience</option>
                                        <option value="0 to 2 years">0 to 2 Years</option>
                                        <option value="2 to 5 years">2 to 5 Years</option>
                                        <option value="5 to 8+ years">5 to 8+ Years</option>
                                        <option value="8 to 12+ years">8 to 12+ Years</option>
                                        <option value="15+ years">15+ Years</option>
                                    </select>
                                    <span className='mt-0 job_boardspancheckadd'>
                                        <input type='checkbox' checked={formData.experience_range === "unknown"}
                                        onChange={(e) => 
                                            handleInputChange({
                                            target: { name: "experience_range", value: e.target.checked ? "unknown" : "" }
                                            })
                                        }/>
                                    Unknown</span>
                                    {errors.experience_range && <p style={{color:"red"}}>{errors.experience_range}</p>}
                                </Grid>
                                <Grid size={{sm:5.5, xs:12}} container flexDirection="column" >
                                    <span>Technology<small>*</small></span>
                                    <select name="technology" value={formData.technology} onChange={handleInputChange} >
                                        <option value="">Select</option>
                                        <option value="ServiceNow">ServiceNow</option>
                                    </select>
                                </Grid>
                                <Grid size={{sm:5.5, xs:12}} container flexDirection="column" >
                                    <span>Accepted Citizenship Status<small className={formData.citizenship_status==="unknown" ? "grayed_star":""}>*</small></span>
                                    <Select
                                        className="basic-single select_withsearch"
                                        isMulti
                                        classNamePrefix="select"
                                        value={selectedStatusCity}
                                        defaultValue={null}
                                        isDisabled={
                                            formData.citizenship_status === "unknown" ||
                                            (Array.isArray(formData.citizenship_status) &&
                                            formData.citizenship_status.includes("unknown"))
                                        }
                                        name="citizenship_status"
                                        options={citizenshipStatuses
                                            ?.filter((status) => !selectedResStatusCity?.some((res) => res.value === status.status)) // Exclude already selected values
                                            .map((status) => ({
                                                label: status.status,
                                                value: status.status,
                                            }))}
                                        onChange={handleStatusChange}
                                    />
                                    <span className='mt-1 job_boardspancheckadd'>
                                        <input type='checkbox' checked={
                                            formData.citizenship_status === "unknown" ||
                                            (Array.isArray(formData.citizenship_status) &&
                                            formData.citizenship_status.includes("unknown"))}
                                        onChange={(e) => {
                                            handleInputChange({
                                            target: { name: "citizenship_status", value: e.target.checked ? "unknown" : "" }
                                            });
                                            setStatusCity(null);
                                        }}/>
                                    Unknown</span>
                                    {errors.citizenship_status && <p style={{color:"red"}}>{errors.citizenship_status}</p>}
                                </Grid>
                                <Grid size={{sm:5.5, xs:12}} container flexDirection="column" >
                                    <span>Restricted Citizenship Status<small className={formData.restricted_citizenship_status==="unknown" ? "grayed_star":""}>*</small></span>
                                    <Select
                                        className="basic-single select_withsearch"
                                        isMulti
                                        classNamePrefix="select"
                                        value={selectedResStatusCity}
                                        defaultValue={null}
                                        isDisabled={
                                            formData.restricted_citizenship_status === "unknown" ||
                                            (Array.isArray(formData.restricted_citizenship_status) &&
                                            formData.restricted_citizenship_status.includes("unknown"))
                                        }
                                        name="restricted_citizenship_status"
                                        options={citizenshipStatuses
                                            ?.filter((status) => !selectedStatusCity?.some((selected) => selected.value === status.status)) // Exclude already selected values
                                            .map((status) => ({
                                                label: status.status,
                                                value: status.status,
                                            }))}
                                        onChange={handleResStatusChange}
                                    />
                                    <span className='mt-1 job_boardspancheckadd'>
                                        <input type='checkbox' checked={formData.restricted_citizenship_status === "unknown" ||
                                            (Array.isArray(formData.restricted_citizenship_status) &&
                                            formData.restricted_citizenship_status.includes("unknown"))}
                                        onChange={(e) => {
                                            handleInputChange({
                                            target: { name: "restricted_citizenship_status", value: e.target.checked ? "unknown" : "" }
                                            });
                                            setResStatusCity(null);
                                        }}/>
                                    Unknown</span>
                                    {errors.restricted_citizenship_status && <p style={{color:"red"}}>{errors.restricted_citizenship_status}</p>}
                                </Grid>
                                <Grid size={{sm:5.5, xs:12}} container flexDirection="column">
                                    <span>Key Skills<small>*</small></span>
                                    <input
                                        type="text"
                                        value={input}
                                        onChange={handleInputChanger}
                                        onKeyDown={handleKeyDown}
                                        placeholder="Type and press Enter"
                                        style={styles.input}
                                    />
                                    <div style={styles.tagContainer}>
                                        {key_skills.map((tag, index) => (
                                        <div key={index} style={styles.tag}>
                                            {tag}
                                            <button
                                            type="button"
                                            style={styles.removeButton}
                                            onClick={() => removeTag(index)}
                                            >
                                            &times;
                                            </button>
                                        </div>
                                        ))}
                                    </div>
                                    {errors.key_skills && <p style={{color:"Red"}}>{errors.key_skills}</p>}
                                </Grid>
                                <Grid size={{xs:12}} container className="add_jobhead mt-5">
                                    <h4>Poster Profile</h4>
                                </Grid>
                                <Grid size={{sm:5.5, xs:12}} container flexDirection="column" >
                                    <span>Recruiter Name<small className={formData.recruiter_name==="unknown" ? "grayed_star":""}>*</small></span>
                                    <input type='text' placeholder='Name' maxLength="201" name="recruiter_name" value={formData.recruiter_name} onChange={handleInputChange} disabled={formData.recruiter_name === "unknown"}/>
                                    <span className='mt-0 job_boardspancheckadd'>
                                        <input type='checkbox' checked={formData.recruiter_name === "unknown"}
                                        onChange={(e) => 
                                            handleInputChange({
                                            target: { name: "recruiter_name", value: e.target.checked ? "unknown" : "" }
                                            })
                                        }/>
                                    Unknown</span>
                                    {errors.recruiter_name && <p style={{color:"red"}}>{errors.recruiter_name}</p>}
                                </Grid>
                                {opendata === false &&
                                <Grid size={{sm:5.5, xs:12}} container flexDirection="column">
                                    <span>Recruiter Email<small>*</small></span>
                                    <input
                                        type="email"
                                        value={input2}
                                        onChange={handleInputChanger2}
                                        onKeyDown={handleKeyDown2}
                                        placeholder="Type and press Enter"
                                        style={styles.input}
                                    />
                                    <div style={styles.tagContainer}>
                                        {recruiter_email.map((tag, index) => (
                                        <div key={index} style={styles.tag}>
                                            {tag}
                                            <button
                                            type="button"
                                            style={styles.removeButton}
                                            onClick={() => removeTag2(index)}
                                            >
                                            &times;
                                            </button>
                                        </div>
                                        ))}
                                    </div>
                                    {errors.recruiter_email && <p style={{color:"Red"}}>{errors.recruiter_email}</p>}
                                </Grid>}
                                <Grid size={{sm:5.5, xs:12}} container flexDirection="column" >
                                    <span>Recruiter Company<small className={formData.recruiter_company==="unknown" ? "grayed_star":""}>*</small></span>
                                    <input type='text' name="recruiter_company" value={formData.recruiter_company} maxLength="201" onChange={handleInputChange} disabled={formData.recruiter_company === "unknown"}/>
                                    <span className='mt-0 job_boardspancheckadd'>
                                        <input type='checkbox' checked={formData.recruiter_company === "unknown"}
                                        onChange={(e) => 
                                            handleInputChange({
                                            target: { name: "recruiter_company", value: e.target.checked ? "unknown" : "" }
                                            })
                                        }/>
                                    Unknown</span>
                                    {errors.recruiter_company && <p style={{color:"red"}}>{errors.recruiter_company}</p>}
                                </Grid>
                                <Grid size={{sm:5.5, xs:12}} container flexDirection="column" >
                                    <span>Recruiter Phone<small className={formData.recruiter_phone==="unknown" ? "grayed_star":""}>*</small></span>
                                    <input type='text' name="recruiter_phone" value={formData.recruiter_phone} disabled={formData.recruiter_phone === "unknown"}
                                        autoComplete="new-password"
                                        onChange={handlePhoneNumberChange}
                                        placeholder="***_***_****"
                                        maxLength="14"
                                        className={errors.recruiter_phone ? 'input-error' : ''}
                                    />
                                    <span className='mt-0 job_boardspancheckadd'>
                                        <input type='checkbox' checked={formData.recruiter_phone === "unknown"}
                                        onChange={(e) => 
                                            handleInputChange({
                                            target: { name: "recruiter_phone", value: e.target.checked ? "unknown" : "" }
                                            })
                                        }/>
                                    Unknown</span>
                                    {errors.recruiter_phone && <p style={{color:"red"}}>{errors.recruiter_phone}</p>}
                                </Grid>
                                <Grid size={{xs:12}} container flexDirection="column">
                                    {openEmaildata ?
                                        <span>Title<small >*</small></span>:
                                        <span>Email Subject<small >*</small></span>
                                    }
                                    <input type='text' name="title" value={formData.title} maxLength="201" onChange={handleInputChange}/>
                                    {errors.title && <p style={{color:"red"}}>{errors.title}</p>}
                                </Grid>
                                <Grid size={{sm:5.5, xs:12}} container flexDirection="column">
                                    <span>Role Type<small >*</small></span>
                                    <select name="role_type" value={formData.role_type} onChange={handleInputChange}>
                                        <option value="">Select</option>
                                        <option value="Admin">Admin</option>
                                        <option value="Developer">Developer</option>
                                        <option value="Business Analyst">Business Analyst</option>
                                        <option value="Consultant">Consultant</option>
                                        <option value="Manager">Manager</option>
                                        <option value="Product Owner">Product Owner</option>
                                        <option value="Business System Analyst">Business System Analyst</option>
                                        <option value="Developer/Administrator">Developer/Administrator</option>
                                        <option value="Others">Others</option>
                                    </select>
                                    {errors.role_type && <p style={{color:"red"}}>{errors.role_type}</p>}
                                </Grid>
                                <Grid size={{sm:5.5, xs:12}} container flexDirection="column" >
                                    <span>Poster Type<small className={formData.poster_type==="unknown" ? "grayed_star":""}>*</small></span>
                                    <select name="poster_type" value={formData.poster_type} onChange={handleInputChange} disabled={formData.poster_type === "unknown"}>
                                        <option value="">Select</option>
                                        <option value="Staffing Company">Staffing Company</option>
                                        <option value="Implementation Partners">Implementation Partners</option>
                                        <option value="Direct Requirement">Direct Requirement</option>
                                    </select>
                                    <span className='mt-0 job_boardspancheckadd'>
                                        <input type='checkbox' checked={formData.poster_type === "unknown"}
                                        onChange={(e) => 
                                            handleInputChange({
                                            target: { name: "poster_type", value: e.target.checked ? "unknown" : "" }
                                            })
                                        }/>
                                    Unknown</span>
                                    {errors.poster_type && <p style={{color:"red"}}>{errors.poster_type}</p>}
                                </Grid>
                            </Grid>
                            <Grid size={{xs:12}} container flexDirection="column" className="editor_sunsinput">
                                {openEmaildata ?
                                    <span className='span_editorshows'>Job Description<small >*</small></span>:
                                    <span className='span_editorshows'>Email Body<small >*</small></span>
                                }
                                <JoditEditor
                                    value={formData.description}
                                    config={{
                                        pasteHTML: '', // default paste content
                                        cleanHTML: false,
                                        askBeforePasteHTML: false,
                                        askBeforePasteFromWord: false,
                                        disablePlugins: ['pasteStorage'], // optionally disable paste-related cleanup plugins
                                        iframe: false,
                                        editHTMLDocumentMode: false,
                                        enableDragAndDropFileToEditor: false,
                                        processPasteHTML: html => {
                                        return html.replace(/</g, '&lt;').replace(/>/g, '&gt;');
                                        },
                                        enter: 'BR',
                                        beautifyHTML: false,
                                        events: {
                                            onPaste: (event) => {
                                                console.log("Pasted!", event);
                                            },
                                        },
                                        paste: {
                                        cleanOnPaste: false,
                                        replaceNewlines: false
                                        },
                                        controls: {
                                            font: {
                                                list: {
                                                    'calibri': 'Calibri'
                                                }
                                            },
                                            removeFormat: {
                                                name: 'removeFormat',
                                                icon: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512"><!--!Font Awesome Free v7.0.1 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2025 Fonticons, Inc.--><path d="M178.5 416l123 0 65.3-65.3-173.5-173.5-126.7 126.7 112 112zM224 480l-45.5 0c-17 0-33.3-6.7-45.3-18.7L17 345C6.1 334.1 0 319.4 0 304s6.1-30.1 17-41L263 17C273.9 6.1 288.6 0 304 0s30.1 6.1 41 17L527 199c10.9 10.9 17 25.6 17 41s-6.1 30.1-17 41l-135 135 120 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-288 0z"/></svg>',
                                                tooltip: 'Remove Format',
                                            },
                                            removeBg: {
                                                name: "removeBg",
                                                tooltip: "Remove Background Color",
                                                icon: "eraser",
                                                exec: (editor) => {
                                                editor.s.focus();
                                            
                                                const sel = editor.s.sel;
                                                if (sel && sel.rangeCount > 0) {
                                                    const range = sel.getRangeAt(0);
                                                    const contents = range.cloneContents();
                                                    const div = editor.ownerDocument.createElement("div");
                                                    div.appendChild(contents);
                                                    
                                                    const elements = div.querySelectorAll("*");
                                                    elements.forEach(el => {
                                                    if (el.style && el.style.backgroundColor) {
                                                        el.style.backgroundColor = "";
                                                    }
                                                    });
                                                    
                                                    editor.selection.remove();
                                                    editor.selection.insertHTML(div.innerHTML);
                                                }
                                                }
                                            },
                                            fontsize: {
                                                list: {
                                                "12px": "Paragraph - 12",
                                                "14px": "Small - 14",
                                                "16px": "Default - 16",
                                                "18px": "Medium - 18",
                                                "24px": "Large - 24"
                                                }
                                            }, 
                                        },
                                        width: "100%",
                                        minWidth: "500px",
                                        toolbarAdaptive: false,
                                        toolbarSticky: false,
                                        buttons: [
                                            "source", "|",
                                            "bold", "italic", "underline", "strikethrough","spellcheck", "|",
                                            "fontsize", "brush","removeBg", "|", // Font size, font style, text color // "font",
                                            "ul", "ol", "|",
                                            "align", "|",
                                            "image", "file", "table", "link", "|",
                                            "undo", "redo", "removeFormat", "|",
                                            "hr", "fullsize" // Additional options
                                        ], 
                                        useIframe: false,
                                        defaultFont: "calibri", // Default font
                                        style: {
                                            fontFamily: "calibri", // Set font globally
                                        },
                                        showCharsCounter: false, // Hides character counter
                                        showWordsCounter: false, // Hides word counter
                                    }}
                                    onChange={debouncedOnChange}
                                />
                                {errors.description && <p style={{color:"red"}}>{errors.description}</p>}
                            </Grid>
                            {errorMessage && <p style={{ color: 'red',width: '100%' }}>{errorMessage}</p>}
                            <Grid size={{xs:12}} container className="gap-3 my-3">
                                <button type="button" onClick={handleSubmit} className='registersendbtn2'>{submitloader ? <img src={require('../../assets/whiteloader.gif')} alt=''/> : 'Submit'}</button>
                                <button type='button' className='registersendbtn1' onClick={()=>navigate("/job-board")}>Cancel</button>
                            </Grid>
                        </form>
                    </Grid>
                }
            </Grid>
        </div>
    </div>
  )
}

export default EditJobs
